'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'gem';
var width = 512;
var height = 512;
var aliases = [128142];
var unicode = 'f3a5';
var svgPathData = 'M267 468.3L256 480 245 468.3 0 208 112 32 400 32 512 208 267 468.3zM490 208L22 208 256 456.7 490 208zm-7.2-16l-89.7-141-119.8 141 209.6 0zM374.7 48L137.3 48 256 187.6 374.7 48zM118.9 51L29.1 192 238.7 192 118.9 51z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;